import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationDeviceSectionAssayCreateRequest,
    ConfigurationDeviceSectionAssayResponse
} from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device-section-assay/configuration-device-section-assay.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class ConfigurationDeviceSectionAssayService {
    async create(laboratoryId: number, request: ConfigurationDeviceSectionAssayCreateRequest): Promise<ConfigurationDeviceSectionAssayResponse> {
        const response = await axios.post<ConfigurationDeviceSectionAssayResponse>(`/configuration/laboratories/${laboratoryId}/deviceSectionAssays`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationDeviceSectionAssayResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationDeviceSectionAssayResponse>>(`/configuration/laboratories/${laboratoryId}/deviceSectionAssays`, { ...filterModel }, { params })
        return response.data
    }

    async delete(laboratoryId: number, deviceSectionAssayId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/deviceSectionAssays/${deviceSectionAssayId}`)
        return response.data
    }
}

export const configurationDeviceSectionAssayService = new ConfigurationDeviceSectionAssayService()
